import api from "./api";

export const CategoriaGraficoService = {
  buscarVisiveisUsuario: () => api.get(`/categoria-grafico`),
};
